import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/keyfeature/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      let response;
      if (id) {
        response = await dispatch(Update({ id, data }));
      } else {
        response = await dispatch(Create(data));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({ name: "" });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
    
        setShowError(response.payload?.response?.data?.errors);
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Country", error);
    }
  };
  return (
    <>
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Name"
                  {...register("name", {
                    required: "Name is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.name && (
                  <span className="text-danger">{errors.name?.message}</span>
                )}
              </div>
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({ name: "" });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
